import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios' // 确保已安装 axios

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sessionLoginStatus: sessionStorage.getItem('loginStatus') || '0', // 登录状态
    logindialog: false // 新增：登录弹窗显示状态
  },
  mutations: {
    setSessionLoginStatus(state, newValue) {
      state.sessionLoginStatus = newValue
      sessionStorage.setItem('loginStatus', newValue)
    },
    // 新增：控制登录弹窗显示/隐藏
    setLoginDialog(state, newValue) {
      state.logindialog = newValue
    }
  },
  actions: {
    async checkToken({ commit }) {
      try {
        const res = await axios.get('/api/validate-token')
        commit('setSessionLoginStatus', res.data.valid ? '1' : '0')
      } catch (error) {
        commit('setSessionLoginStatus', '0')
      }
    },
    // 新增：可选的弹窗控制 action
    toggleLoginDialog({ commit }, isOpen) {
      commit('setLoginDialog', isOpen)
    }
  },
  getters: {
    isLoggedIn: state => state.sessionLoginStatus === '1',
    // 新增：获取弹窗状态
    shouldShowLoginDialog: state => state.logindialog
  }
})